module.exports = __webpack_public_path__ + "h5/img/home4.d4cb3b62.png";